import { ProductOptionChoiceDetailsInstance } from 'src/store/_models/productOptionChoiceDetails';
import { EDIT_TOOLS } from './BaseToolbar.constants';
import { LookupCodes, LookupCodesWithColorChoice } from 'src/constants/lookup.constants';

export const isEditOptionCode = (optionCode: string): boolean => {
  return (Object.values(EDIT_TOOLS) as string[]).includes(optionCode);
};

export const isColorToolOptionChoice = (
  optionCode?: string,
  choiceDetails?: ProductOptionChoiceDetailsInstance,
): boolean => {
  return (
    !!optionCode && LookupCodesWithColorChoice.includes(optionCode as LookupCodes) && typeof choiceDetails === 'object'
  );
};
